import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './user-info.scss';
import UserInfoBody from './user-info-tooltip';

export default function UserInfo({
  userName,
  userEmail,
  userRole,
  shortName,
  direction,
  ...props
}) {
  let timeout;
  const [active, setActive] = useState(false);
  const [leftPosition, setLeftPosition] = useState();
  const [topPosition, setTopPosition] = useState();
  const [userInfoHeight, setUserInfoHeight] = useState(0);
  const [userInfoWidth, setUseInfoWidth] = useState(0);
  const userInfoContainer = useRef(null);
  // const [colorCode, setColorCode] = useState('');
  useEffect(() => {
    setUserInfoHeight(userInfoContainer?.current?.clientHeight);
    setUseInfoWidth(userInfoContainer?.current?.clientWidth);
  });

  const showUserInfo = (e) => {
    if (direction === 'right') {
      timeout = setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        if (rectangle.x + rectangle.width + userInfoWidth > window.innerWidth) {
          setLeftPosition(rectangle.x - userInfoWidth);
        } else {
          setLeftPosition(rectangle.x + rectangle.width + 2);
        }
        if (
          rectangle.y + rectangle.height + userInfoHeight >
          window.innerHeight
        ) {
          setTopPosition(rectangle.y - userInfoHeight);
        } else {
          setTopPosition(rectangle.y - rectangle.height);
        }

        setActive(true);
      }, 200);
    } else if (direction === 'left') {
      setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        setLeftPosition(rectangle.x - userInfoWidth);
        setTopPosition(rectangle.y - rectangle.height);
        setActive(true);
      }, 200);
    } else {
      setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        if (rectangle.x + rectangle.width + userInfoWidth > window.innerWidth) {
          setLeftPosition(rectangle.x - userInfoWidth);
        } else {
          setLeftPosition(rectangle.x + rectangle.width - 10);
        }
        if (
          rectangle.y + rectangle.height + userInfoHeight >
          window.innerHeight
        ) {
          setTopPosition(rectangle.y - userInfoHeight);
        } else {
          setTopPosition(rectangle.y - rectangle.height);
        }
        setActive(true);
      }, 200);
    }
  };
  const showInfo = () => {
    setActive(true);
  };
  const hideUserInfo = () => {
    clearInterval(timeout);
    setTimeout(() => {
      setActive(false);
    }, 200);
  };

  return (
    <div
      className="user-info-wrapper"
      onMouseEnter={showUserInfo}
      onMouseLeave={hideUserInfo}
    >
      {props.children}

      <UserInfoBody
        active={active}
        left={leftPosition}
        top={topPosition}
        userName={userName}
        userEmail={userEmail}
        userRole={userRole}
        userUrl={props.userUrl}
        shortName={shortName}
        ref={userInfoContainer}
        mouseEnter={showInfo}
        mouseLeave={hideUserInfo}
        updatedOn={props.updatedOn}
        status={props?.status}
        byTime={props?.byTime}
      />
    </div>
  );
}

UserInfo.propTypes = {
  children: PropTypes.node.isRequired,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  userRole: PropTypes.string,
  userUrl: PropTypes.string,
  shortName: PropTypes.string,
  direction: PropTypes.string,
  updatedOn: PropTypes.string,
  status: PropTypes.string,
  byTime: PropTypes.string,
};
UserInfo.defaultProps = {
  userName: '',
  userEmail: '',
  userRole: '',
  userUrl: '',
  shortName: '',
  direction: '',
  updatedOn: '',
  status: '',
  byTime: '',
};
